const menu_items = [
	{
		name: "Biz haqimizda",
		ru: "О нас",
		uz: "Biz haqimizda",
		id: 13,
		path: "/about-us",
		children: [
			{
				name: "TTV sertifikatlashtirish idorasi",
				ru: "Орган по сертификации ТСТ",
				uz: "TTV sertifikatlashtirish idorasi",
				id: 1,
				path: "/sertifikatsiya-organi",
			},
			{
				name: "TTV sertifikatlashtirish sinov markazi",
				ru: "Сертификационный испытательный центр ТСТ",
				uz: "TTV sertifikatlashtirish sinov markazi",
				path: "/sertifikatsiya-sinov-markazi",
				id: 2,
			},
			{
				name: "TQTT texnik vositalarini sertifikatlashtirish maxsus idorasi",
				ru: "Специальный орган по сертификации технических средств СОРМ",
				uz: "TQTT texnik vositalarini sertifikatlashtirish maxsus idorasi",
				path: "/sertifikatsiya-maxsus-sinov-markazi",
				id: 3,
			},
			// {
			//   name: "TQTT texnik vositalari maxsus sinov laboratoriyasi",
			//   ru: "Специальная испытательная лаборатория технических средств СОРМ",
			//   uz: "TQTT texnik vositalari maxsus sinov laboratoriyasi",
			//   path: "/sertifikatsiya-maxsus-organi",
			//   id: 4,
			// },
			{
				name: "Ko'p beriladigan savollar",
				ru: "Часто задаваемые вопросы",
				uz: "Ko'p beriladigan savollar",
				path: "/most-questions",
				id: 5,
			},
		],
	},
	{
		name: "Yangiliklar",
		id: 21,
		uz: "Yangiliklar",
		ru: "Новости",
		path: "/news",
	},
	{
		name: "Xujjatlar",
		ru: "Документы",
		uz: "Xujjatlar",
		id: 15,
		path: "/docs",
	},
	{
		name: "Jixozlar",
		ru: "Оборудования",
		uz: "Jixozlar",
		id: 16,
		path: "/gadgets",
	},
	{
		name: "Murojaat",
		uz: "Murojaat",
		ru: "Обращение",
		id: 76,
		path: "/appeal",
	},
	{
		name: "Bog'lanish",
		uz: "Bog'lanish",
		ru: "Контакты",
		id: 77,
		path: "/connection",
	},
];

import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {switchLang} from "../../redux/actions/actions";
import MenuItems from "./MenuItems";
import logo from "../../assets/logo.svg";
import MobileNavbar from "./MobileNavbar";
import "./index.css"

export default function Header() {
	const depthLevel = 0;
	const dispatch = useDispatch()
	const {pathname} = useLocation()
	
	const {location} = useSelector((state) => state.location);
	
	const [isMobileOpen, setIsMobileOpen] = useState(false);
	
	useEffect(() => {
		setIsMobileOpen(false)
	}, [pathname])
	
	const handleChange = (e) => {
		dispatch(switchLang(e));
	};
	
	return (
		<>
			<nav className="w-full fixed top-0 z-50 text-white shadow-md navbar lg:hidden block">
				{/* TOP BAR */}
				<div className="w-full backdrop-blur bg-white/80">
					<div className="container mx-auto">
						<div className="flex items-center justify-between py-4">
							{/* LEFT LOGO */}
							<Link to={"/"} className="flex items-center gap-3">
								<img
									src={logo}
									alt="logo"
									className="h-8"
								/>
							</Link>
							
							{/* CENTER SIDE CONTACT */}
							<div
								className="flex items-center space-x-6 bg-[#6D758F]/5 border border-[#6D758F]/10 p-3 rounded-[10px]">
								<a
									target="_blank"
									rel="noreferrer"
									href="https://unicon.uz/"
									className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
								>
									{
										location === "uz"
											? "Kompaniya"
											: location === "ru"
												? "Компания"
												: "Company"
									}
								</a>
								<a
									target="_blank"
									rel="noreferrer"
									href="https://dc.unicon.uz/"
									className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
								>
									{
										location === "uz"
											? "Data markaz"
											: location === "ru"
												? "Дата-центр"
												: "Data Center"
									}
								</a>
								<a
									target="_blank"
									rel="noreferrer"
									href="https://xizmatlar.unicon.uz/"
									className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
								>
									{
										location === "uz"
											? "Barcha xizmatlar"
											: location === "ru"
												? "Все услуги"
												: "All Services"
									}
								</a>
								<a
									target="_blank"
									rel="noreferrer"
									href="https://certificate.unicon.uz/"
									className={`text-sm text-[#464897] border-b-2 border-b-[#464897] font-semibold`}
								>
									{
										location === "uz"
											? "Sertifikatsiya"
											: location === "ru"
												? "Сертификация"
												: "Certification"
									}
								</a>
								<a
									target="_blank"
									rel="noreferrer"
									href="https://edu.unicon.uz/"
									className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
								>
									{
										location === "uz"
											? "O'quv markaz"
											: location === "ru"
												? "Учебный центр"
												: "Training Center"
									}
								</a>
								<a
									target="_blank"
									rel="noreferrer"
									href="https://stt2.unicon.uz/"
									className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
								>
									{
										location === "uz"
											? "Standartlar"
											: location === "ru"
												? "Стандарты"
												: "Standards"
									}
								</a>
							</div>
							
							{/* RIGHT SIDE CONTACT */}
							<div className="flex items-center gap-6">
								<div className="flex items-center gap-3">
									<div className="w-9 h-9 bg-[#464897] rounded-full flex items-center justify-center text-white">
										<i className="ri-phone-fill"></i>
									</div>
									<div className="leading-4 text-[#19213D]">
										<p className="text-sm">
											{
												location === "uz"
													? "Yagona koll-markaz"
													: location === "ru"
														? "Единый колл-центр"
														: "Unified Call Center"
											}
										</p>
										<p className="font-semibold">+998 71 211 88 88</p>
									</div>
								</div>
								
								{/* LANGUAGE */}
								<div className="relative">
									<div className="flex items-center">
										<select
											value={location}
											onChange={(e) => handleChange(e.target.value)}
											className="p-2 bg-transparent text-[#19213D] text-sm cursor-pointer outline-none focus:outline-none font-bold"
										>
											<option value="uz">UZ</option>
											<option value="ru">RU</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div className={`bg-white/25 backdrop-blur py-2`}>
					<div className="container mx-auto">
						<ul className="flex items-center whitespace-nowrap justify-between">
							<div className="
								menus flex items-center lg3:justify-start whitespace-nowrap justify-between w-auto"
							>
								{menu_items.map((menu, index) => (
									<MenuItems
										items={menu} key={index} depthLevel={depthLevel}
										showDivider={index !== menu_items.length - 1}
									/>
								))}
							</div>
							<div className="flex items-center gap-2">
								<div className="flex gap-1 text-[#464897]">
									<a
										target="_blank"
										className="p-2 text-3xl xs:text-base px-1 rounded-full flex"
										href="https://www.instagram.com/unicon.uz_official/"
									>
										<i className="ri-instagram-line"></i>
									</a>
									<a
										target="_blank"
										className="p-2 text-3xl xs:text-base px-1 rounded-full flex"
										href="https://www.facebook.com/uniconuz"
									>
										<i className="ri-facebook-circle-fill"></i>
									</a>
									<a
										target="_blank"
										className="p-2 text-3xl xs:text-base px-1 rounded-full flex"
										href="https://t.me/uniconcompany"
									>
										<i className="ri-telegram-2-fill"></i>
									</a>
									<a
										target="_blank"
										className="p-2 text-3xl xs:text-base px-1 rounded-full flex"
										href="https://www.youtube.com/@unicon.uz_official/"
									>
										<i className="ri-youtube-fill"></i>
									</a>
								</div>
								<a
									target="_blank"
									rel="noreferrer"
									href="https://xizmatlar.unicon.uz/service/25"
									className="font-bold border border-[#464897] text-[#464897] px-5 py-2 rounded-md hover:bg-[#464897] hover:text-white transition">
									{
										location === "uz"
											? "Onlayn shartnoma"
											: location === "ru" ?
												"Онлайн договор" : "Online contract"
									}
								</a>
							</div>
						</ul>
					</div>
				</div>
			</nav>
			
			{/* TOP NAV (MOBILE ONLY) */}
			<div className="w-full bg-white shadow-md px-4 py-3 lg:flex items-center justify-between hidden">
				<Link to={"/"} className="flex items-center gap-3">
					<img
						src={logo}
						alt="logo"
						className="h-8"
					/>
				</Link>
				
				<button
					onClick={() => setIsMobileOpen(true)}
					className="text-[#374151] text-xl px-3 py-2 rounded-md"
				>
					<i className="ri-menu-line"></i>
				</button>
			</div>
			
			<MobileNavbar open={isMobileOpen} setOpen={setIsMobileOpen} menu_items={menu_items}/>
		</>
	);
}

// import { useState, useEffect, useRef } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { switchLang } from "../../redux/actions/actions";
// import MenuItems from "./MenuItems";
// import logo from "../../assets/logo.svg";
// import { useTranslation } from "react-i18next";
// import "../../index.css";
// import "./index.css";
// import Rek15 from "../../assets/rek15.png";
// import Rek25 from "../../assets/rek25.png";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import { Autoplay } from "swiper/modules";
// import VanillaTilt from "vanilla-tilt";
//
// function Tilt(props) {
// 	const { options, ...rest } = props;
// 	const tilt = useRef(null);
//
// 	useEffect(() => {
// 		VanillaTilt.init(tilt.current, options);
// 	}, [options]);
//
// 	return <div ref={tilt} {...rest} />;
// }
//
// const Header = () => {
// 	const depthLevel = 0;
// 	const dispatch = useDispatch();
// 	const [navOpen, setNavOpen] = useState(false);
// 	const location1 = useLocation();
// 	const { location } = useSelector((state) => state.location);
// 	const { pathname } = useLocation();
// 	const { t } = useTranslation();
//
// 	const handleClick = () => {
// 		setNavOpen(!navOpen);
// 	};
//
// 	const handleChange = (e) => {
// 		dispatch(switchLang(e.target.value));
// 	};
//
// 	useEffect(() => {
// 		setNavOpen(false);
// 	}, [pathname]);
//
// 	const [move, setMove] = useState(false);
// 	useEffect(() => {
// 		window.addEventListener("scroll", () => {
// 			if (window.scrollY > 50) {
// 				setMove(true);
// 			} else {
// 				setMove(false);
// 			}
// 		});
// 	}, []);
//
// 	return (
// 		<>
// 			<nav
// 				className={
// 					location1.pathname === "/" && move
// 						? `py-5 md:hidden desktop z-50 fixed w-full text-[#fff] duration-300 ${
// 								move
// 									? "pt-5 bg-[#0004] text-[#fff]"
// 									: `${pathname !== "/" && "bg-[#0004]"}`
// 						  }`
// 						: location1.pathname !== "/"
// 						? `py-5 md:hidden desktop z-50 fixed w-full text-[#fff] duration-300 ${
// 								move
// 									? "pt-5 bg-[#0004] text-[#fff]"
// 									: `${pathname !== "/" && "bg-[#0007]"}`
// 						  }`
// 						: `py-5 pt-5 md:hidden desktop fixed z-50 w-full text-[#fff] duration-300 ${
// 								move ? "bg-[#0004] text-[#fff]" : `${pathname !== "/" && ""}`
// 						  }`
// 				}
// 			>
// 				<div className="container mx-auto">
// 					<div className="flex items-center justify-between">
// 						<Link to="/" className="logo w-[190px] h-[25px]">
// 							<img src={logo} alt="" className="w-full h-full" />
// 						</Link>
// 						<div className="flex items-center gap-7">
// 							<div className="flex items-center gap-1">
// 								<div className="px-2 flex items-center gap-3">
// 									<div
// 										className={`w-[1px] h-9 ${move ? "bg-white" : ""}`}
// 									></div>
//
// 									<div
// 										className={`w-[1px] h-9 ${move ? "bg-white" : ""}`}
// 									></div>
// 								</div>
// 								<select
// 									className="outline-none text-xl font-bold bg-transparent"
// 									defaultValue={location}
// 									onChange={handleChange}
// 								>
// 									<option
// 										className="font-bold bg-logo"
// 										style={{
// 											display:
// 												location === "ru" || location === "en" ? "" : "none",
// 										}}
// 										value="uz"
// 									>
// 										uz
// 									</option>
// 									<option
// 										className="font-bold bg-logo"
// 										style={{
// 											display:
// 												location === "uz" || location === "en" ? "" : "none",
// 										}}
// 										value="ru"
// 									>
// 										ru
// 									</option>
// 									{/* <option
//                       className="font-bold bg-logo"
//                       style={{ display: location === "uz" || location === "ru" ? "" : "none" }}
//                       value="en"
//                     >
//                       en
//                     </option> */}
// 								</select>
// 							</div>
// 						</div>
// 					</div>
//
// 					{/* border-t-[#3A375E] */}
// 					<div
// 						className={`xl2:pt-1 ${
// 							move ? "border-t-[1px] border-t-white" : ""
// 						}`}
// 					>
// 						<ul className="menus flex justify-end lg3:justify-start whitespace-nowrap flex-wrap">
// 							{menu_items.map((menu, index) => (
// 								<MenuItems items={menu} key={index} depthLevel={depthLevel} />
// 							))}
// 						</ul>
// 					</div>
// 				</div>
// 			</nav>
// 		</>
// 	);
// };
//
// export default Header;
